import React, { useState } from 'react';
import styles from '../styles';

const ServiceCard = ({ title, description }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      style={{ ...styles.serviceCard, ...(hovered ? styles.serviceCardHover : {}) }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <h3 style={styles.serviceTitle}>{title}</h3>
      <p style={styles.serviceDesc}>{description}</p>
    </div>
  );
};

export default ServiceCard;
